import { Tenancy, TENANT } from '@lib/firebase/types'
import {
  SecretsManagerClient,
  GetSecretValueCommand,
} from '@aws-sdk/client-secrets-manager'

const TWELVE_DAYS_IN_MS = 12 * 60 * 60 * 24 * 1000

export const core = {
  logoutUrl: '/api/logout',
  loginUrl: '/api/login',
  isDebug: import.meta.env.FIREBASE_DEBUG_AUTH === 'true',
  authPageUrl: '/signin',
  appPageUrl: '/o',
  staffAuthPageUrl: '/staff/signin',
  staffAppPageUrl: '/staff/o',
}
export const cookieConfig = {
  name: 'cloudmixApp', // required
  // Keys are required unless you set `signed` to `false`.
  // The keys cannot be accessible on the client side.
  keys: [
    import.meta.env.COOKIE_SECRET_CURRENT,
    import.meta.env.COOKIE_SECRET_PREVIOUS,
  ],
  httpOnly: true,
  maxAge: TWELVE_DAYS_IN_MS,
  overwrite: true,
  path: '/',
  sameSite: 'lax',
  secure: import.meta.env.NEXT_PUBLIC_COOKIE_SECURE === 'true',
  signed: true,
}
export const getTenanancyCookieName = () => 'tenancy'

export const firebaseClientInitConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_PUBLIC_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  tenantIds: {
    staff:
      import.meta.env.VITE_FIREBASE_STAFF_TENANT_ID || 'staff-members-qmapa',
    endUser: import.meta.env.VITE_FIREBASE_USER_TENANT_ID || 'end-users-4mvub',
  },
}

export const getFirebaseAdminInitConfig = async () => {
  // The private key must not be accessible on the client side.
  let privateKey: string
  if (import.meta.env.FIREBASE_PRIVATE_KEY) {
    privateKey = JSON.parse(import.meta.env.VITE_FIREBASE_PRIVATE_KEY)
  } else {
    const client = new SecretsManagerClient()
    const response = await client.send(
      new GetSecretValueCommand({
        SecretId: 'firebase-admin-sdk',
      })
    )
    const secretJson = JSON.parse(response.SecretString as string)
    privateKey = secretJson.private_key
  }

  const clientEmail = import.meta.env.FIREBASE_CLIENT_EMAIL
  const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID

  if (!clientEmail || !projectId || !privateKey) {
    throw new Error('Missing Firebase configuration values.')
  }

  return {
    credential: {
      clientEmail,
      projectId,
      privateKey,
    },
    databaseURL: 'https://optimal-primer-320705.firebaseio.com',
  }
}

export const getTenantId = (tenant?: Tenancy | null) => {
  let tenantId: string | null = null
  switch (tenant) {
    case TENANT.staff:
      tenantId = import.meta.env.VITE_FIREBASE_STAFF_TENANT_ID
      break
    case TENANT.user:
    default:
      tenantId = import.meta.env.VITE_FIREBASE_USER_TENANT_ID
      break
  }
  if (!tenantId) {
    throw new Error(`Tenant ID is undefined for tenant: ${tenant}`)
  }

  return tenantId
}

export const getFirebasePublicAPIKey = () =>
  import.meta.env.VITE_FIREBASE_PUBLIC_API_KEY

export const getIsDebug = () => core.isDebug
